import { ActionsCell } from "../../../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../../../Component/Common/Components/DataTable/DefaultCell";
import { FileManagementImportSearchDto } from "../../../../../Component/Model/Dto/FileManagement";
import { ActionType, TableColumn } from "../../../../../Component/Model/Table/Table";
import { TableDateTimeHelper } from "../../../../../Component/Model/helpers";

interface FileManagementImportTableRow {
    fileName: string;
    dateImported: string;
    importedBy: string;
    actions: ActionType[];
}

export interface FileManagementImportTable {
    columns: Array<TableColumn>;
    rows: Array<FileManagementImportTableRow>;
}

export function FileManagmentImportTableMapper(results: FileManagementImportSearchDto[], downloadFile: (id: number) => void, openImportModal: (id: number) => void): FileManagementImportTable {
    const columns = [
        { Header: 'Name Of File', accessor: 'fileName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Date Imported', accessor: 'dateImported', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Imported By', accessor: 'importedBy', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
    ];

    if (results.length >= 0) {

        const rows = results.map((item: FileManagementImportSearchDto, index: number) => ({
            fileName: item.fileName,
            dateImported: TableDateTimeHelper(item.dateImported.toString()),
            importedBy: item.importedBy,
            actions: [
                {
                    key: index.toString(),
                    label: 'View data pages',
                    action: () => {
                        openImportModal(item.id);
                    },
                    icon: {
                        color: 'secondary',
                        name: 'visibility',
                    },
                },
                item.downloadable ?
                    {
                        key: index.toString(),
                        label: 'Download File',
                        action: () => {
                            downloadFile(item.id);
                        },
                        icon: {
                            color: 'info',
                            name: 'download'
                        }
                    }
                    :
                    {
                        key: index.toString(),
                        label: `You're only allowed to download files that you've imported`,
                        action: () => { },
                        icon: {
                            color: 'secondary',
                            name: 'download'
                        },
                        disabled: true
                    }
            ]
        }));


        return { columns: columns, rows: rows };
    } else {
        return { columns: columns, rows: [] };
    }
}

